import React from 'react'
import { Header } from 'components/Header'
import { Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useWhoamiContextValue } from 'components/Whoami'
import { useUserPaymentsContextValue } from '../context/UserPaymentsProvider'
import { PayHealthStipendFlow } from '../workflows/PayHealthStipendFlow'

export const UserPaymentsHeader = () => {
  const { state, actions } = useUserPaymentsContextValue()
  const { hasPermission } = useWhoamiContextValue()
  const canPayHealthStipend = hasPermission('payment_admin')
  return (
    <Header
      title="User Payments"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          {canPayHealthStipend ? <PayHealthStipendFlow /> : null}
        </Flex>
      }
    />
  )
}
